<script>
import IconDoc from '@/assets/img/doc.svg'
import IconShield from '@/assets/img/shield.svg'
import IconDiag from '@/assets/img/diag.svg'
import IconDatabases from '@/assets/img/databases.svg'
import IconCalendar from '@/assets/img/calendarV2.svg'
import CardProspect from '@/components/Board/CardProspect.vue'
import UserResource from '@/resources/user.js'

export default {
  name: 'BoardProspectSteps',
  components: {
    CardProspect
  },
  props: {
    searchQuery: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      prospects: [],
      colProspect: [
        {
          name: 'Paysage Patrimonial',
          tagline: 'À compléter',
          icon: IconDoc,
          id: 'col_pp'
        },
        {
          name: 'LCB-FT',
          tagline: 'Vérification',
          icon: IconShield,
          id: 'col_lcbft'
        },
        {
          name: 'Conseil',
          tagline: 'Lettres & rapports',
          icon: IconDiag,
          id: 'col_conseil'
        },
        {
          name: 'Inscription Partenaire',
          tagline: 'Base de données',
          icon: IconDatabases,
          id: 'col_inscription_partenaire'
        },
        {
          name: 'Abonnement',
          tagline: 'Date d\'effet',
          icon: IconCalendar,
          id: 'col_abonnement'
        }
      ]
    }
  },
  computed: {
    filteredProspects () {
      if (!this.searchQuery) {
        return this.prospects
      }
      const query = this.searchQuery.toLowerCase()
      return this.prospects.filter(prospect => {
        const fullName = `${prospect.fullName || ''}`.toLowerCase()
        return fullName.includes(query)
      })
    },
    prospectsByColumn () {
      const columns = {}
      this.colProspect.forEach(col => {
        columns[col.id] = this.filteredProspects.filter(p => p.colonne === col.id)
      })
      return columns
    },
    totalProspectsDisplayed () {
      return this.filteredProspects.length
    }
  },
  created () {
    this.loadProspect()
  },
  methods: {
    async onToggleInscritPartenaire (userId, value) {
      const prospect = this.prospects.find(p => p.id === userId)

      if (value) {
        const name = prospect ? prospect.fullName : 'ce prospect'
        const result = await this.$swal.fire({
          title: 'Confirmation',
          text: 'Avez-vous bien inscrit ' + name + ' dans la base de vos partenaires ?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#AF9376',
          confirmButtonText: 'Confirmer',
          cancelButtonText: 'Annuler'
        })
        if (!result.value) {
          if (prospect) {
            prospect.partenaire_incription = false
          }
          return
        }
      }

      try {
        await UserResource.updateInscritPartenaire(userId, value)
        if (prospect) {
          prospect.partenaire_incription = value
        }
      } catch (error) {
        console.error('Erreur mise à jour inscription partenaire:', error)
        if (prospect) {
          prospect.partenaire_incription = !value
        }
      }
    },
    async loadProspect () {
      this.loading = true
      try {
        const response = await UserResource.getProspectsForDashboard()
        if (response.status === 200) {
          this.prospects = response.data
        }
      } catch (error) {
        console.error('Erreur:', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
	<section class="board-prospect-steps">
		<div v-if="loading" class="board-prospect-steps__loader">
			<span class="board-prospect-steps__spinner"></span>
		</div>
		<div v-else class="dashboard-kanban">
			<div
				v-for="column in colProspect"
				:key="column.id"
				class="dashboard-kanban__column"
			>
				<header class="dashboard-kanban__header">
					<img
						:src="column.icon"
						:alt="column.name"
						class="dashboard-card__icon dashboard-card__icon--small"
					>
					<div class="dashboard-kanban__header-info">
						<h3 class="dashboard-kanban__title">{{ column.name }}</h3>
						<p class="dashboard-kanban__tagline">{{ column.tagline }}</p>
					</div>
					<span class="dashboard-kanban__count">
						{{ prospectsByColumn[column.id].length }}
					</span>
				</header>
				<div class="dashboard-kanban__content">
					<CardProspect
						v-for="prospect in prospectsByColumn[column.id]"
						:key="prospect.id"
						:user="prospect"
						@toggle-inscrit-partenaire="onToggleInscritPartenaire"
					/>
				</div>
			</div>
		</div>
	</section>
</template>

<style scoped>
.board-prospect-steps {
	width: 100%;
	padding: 1rem 0;
}

.board-prospect-steps__loader {
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 3rem 0;
}

.board-prospect-steps__spinner {
	display: inline-block;
	width: 28px;
	height: 28px;
	border: 3px solid rgba(175, 147, 118, 0.2);
	border-top-color: #AF9376;
	border-radius: 50%;
	animation: prospect-spin 0.7s linear infinite;
}

@keyframes prospect-spin {
	to { transform: rotate(360deg); }
}
</style>


// WEBPACK FOOTER //
// BoardProspectSteps.vue?25d215da